import { getVerbalColors } from 'helpers'

/** Builds progress colors from the active foundation theme. */
const style = (theme) => {
    const colors = getVerbalColors(theme['foundations-library'].colors)
    const backgrounds = {}
    const buffers = {}
    for (const color of Object.keys(colors)) {
        backgrounds[`&.progress--bg-${color}`] = { backgroundColor: colors[color] }
        buffers[`&.progress--buffer-${color}`] = { backgroundColor: colors[color] }
    }

    return {
        progress: {
            width: '100%',
            overflow: 'hidden',
            borderRadius: 5,
            ...backgrounds
        },
        buffer: {
            height: '100%',
            ...buffers
        }
    }
}

export default style
